import 'Utils/responsiveHelper';

/* Filtering plugin */
;(function($) {
	function FilteringItems(options) {
		this.options = $.extend({
			container: '.items-holder',
			items: '.item',
			searchField: '.search-field',
			filterHolder: '.filtration-holder',
			filterLinks: '[data-filter]',
			searchForm: '.search-form',
			btnSearch: '.btn-search',
			searchItems: '',
			activeClass: 'active',
			hiddenClass: 'hidden-item',
			noLoadedClass: 'hidden',
			loadingClass: 'loading',
			noResultsClass: 'no-results',
			btnMore: '.btn-more',
			btnFilter: '.btn-apply',
			btnReset: '.btn-clear',
			infiniteScroll: false,
			itemsPerPage: 99999,
			delay: 500
		}, options);

		this.init();
	}

	FilteringItems.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.win = $(window);
			this.page = $('html, body');
			this.holder = $(this.options.holder);
			this.container = this.holder.find(this.options.container);
			this.items = this.container.find(this.options.items).addClass(this.options.noLoadedClass);
			this.filterLinks = this.holder.find(this.options.filterLinks);
			this.filterHolder = this.holder.find(this.options.filterHolder);
			this.filterSelects = this.filterHolder.find('select');
			this.searchField = this.holder.find(this.options.searchField);
			this.searchForm = this.holder.find(this.options.searchForm);
			this.btnSearch = this.holder.find(this.options.btnSearch);
			this.btnMore = this.holder.find(this.options.btnMore);
			this.btnFilter = this.holder.find(this.options.btnFilter);
			this.btnReset = this.holder.find(this.options.btnReset);
			this.activeFilters = {};
			this.activeItems = this.items;
			this.ajaxBusy = false;
			this.isDesktop = false;
			this.count = 0;
		},
		attachEvents: function() {
			var self = this;

			ResponsiveHelper.addRange({
				'..1023': {
					on: () => {
						this.isDesktop = false;
					}
				},
				'1024..': {
					on: () => {
						this.isDesktop = true;
					}
				}
			});

			this.filter = function() {
				self.items.addClass(self.options.hiddenClass);
				self.holder.removeClass(self.options.noResultsClass);

				if (self.searchField.length) {
					self.searchItems();
				} else {
					self.activeItems = self.items;
					self.filterItems();
				}
			};

			this.btnFilter.on('click', (e) => {
				e.preventDefault();
				this.filter();
			});

			this.btnReset.on('click', (e) => {
				e.preventDefault();

				this.resetFilter();
			});

			this.searchForm.on('submit', function(e) {
				e.preventDefault();
				self.filter();
			});

			if (this.btnSearch.length) {
				this.btnSearch.on('click', function(e) {
					e.preventDefault();
					self.filter();
				});
			} else {
				this.searchField.on('keyup', function() {
					self.filter();
				});
			}

			this.btnMore.on('click', function(e) {
				e.preventDefault();

				if (self.activeItems.length > self.count) {
					self.loadBoxes();
				}
			});

			this.scrollHandler = function() {
				if (self.ajaxBusy) return;

				self.checkPosition();
			};

			this.filterSelects.on('change', (e) => {
				e.preventDefault();

				if (this.holder.hasClass('filtration-finder')) {
					this.filterSelects.not($(e.target)).each(function() {
						const currSelect = $(this);

						currSelect.prop('selectedIndex', 0);
						jcf.refresh(currSelect);
					});
				}

				if (this.isDesktop) {
					self.filter();
				}
			});

			this.filterLinks.each((i, elem) => {
				var link = $(elem);
				var list = link.closest('[data-filter-group]');
				var parent = link.parent();

				if (parent.hasClass(this.options.activeClass)) {
					this.filter();
				}

				link.on('click', (e) => {
					e.preventDefault();
					if (this.ajaxBusy) return;

					if (list.data('multiselect')) {
						var state = false;

						if (parent.hasClass(this.options.activeClass)) {
							parent.removeClass(this.options.activeClass);
						} else {
							parent.addClass(this.options.activeClass);
							state = true;
						}

						if (link.data('filter').trim().toLowerCase() === 'all') {
							var allParents = list.children();

							if (state) {
								allParents.addClass(this.options.activeClass);
							} else {
								allParents.removeClass(this.options.activeClass);
							}
						} else {
							this.filterLinks.each(function() {
								var item = $(this);

								if (item.data('filter').trim().toLowerCase() === 'all') {
									if (!state) {
										item.parent().removeClass(this.options.activeClass);
									}

									if (list.find('.' + this.options.activeClass).length === this.filterLinks.length - 1) {
										item.parent().addClass(this.options.activeClass);
									}
								}
							});
						}
					} else {
						if (!parent.hasClass(this.options.activeClass)) {
							this.filterLinks.parent().removeClass(this.options.activeClass);
							parent.addClass(this.options.activeClass);
							this.makeCallback('onChangeFilter', link);
						}
					}

					if (this.holder.hasClass('filtration-finder')) {
						if (this.isDesktop) {
							this.filter();
						}
					} else {
						this.filter();
					}
				});
			});

			this.loadBoxes();

			if (this.options.infiniteScroll) {
				this.win.on('scroll resize orientationchange', this.scrollHandler);
			}
		},
		resetFilter: function() {
			this.filterSelects.each((i, item) => {
				const select = $(item);

				select.prop('selectedIndex', 0);
				jcf.refresh(select);
			});

			this.filterLinks.parent().removeClass(this.options.activeClass);
			this.filterLinks.eq(0).parent().addClass(this.options.activeClass);

			this.filter();
		},
		checkPosition: function() {
			var self = this;

			if (this.win.scrollTop() + ((this.win.height() / 4) * 3) >= this.holder.offset().top + this.holder.outerHeight()) {
				if (self.activeItems.length > self.count) {
					self.loadBoxes();
				}
			}
		},
		searchItems: function() {
			var self = this;
			var value = this.searchField.val().trim().toLowerCase();

			this.activeItems = this.items.filter(function(ind, item) {
				var matched = false;
				var text = $(item).find(self.options.searchItems).text().toLowerCase();

				if (value !== '') {
					if (text.indexOf(value) !== -1) {
						matched = true;
					}
				}

				if (value === '') {
					matched = true;
				}

				return matched;
			});

			this.filterItems();
		},
		filterItems: function() {
			var self = this;

			this.activeFilters = {};

			this.filterLinks.each(function() {
				var link = $(this);
				var list = link.closest('[data-filter-group]');
				var parent = link.parent();

				if (parent.hasClass(self.options.activeClass)) {
					var value = link.data('filter');
					var category = list.data('filter-group');

					self.combineFilters(category, value);
				}
			});

			this.filterSelects.each(function() {
				var currSelect = $(this);
				var value = currSelect.val().trim().toLowerCase();
				var category = currSelect.data('filter-group');

				self.combineFilters(category, value);
			});

			$.each(this.activeFilters, function(key, value) {
				self.activeItems = self.activeItems.filter(function(ind, item) {
					var textArr = $(item).data(key).toString().split(',');
					var matched = false;

					for (var i = 0; i < textArr.length; i++) {
						if (value.includes(textArr[i].trim().toLowerCase())) {
							matched = true;
						}
					}

					return matched;
				});
			});

			this.activeItems.removeClass(this.options.hiddenClass).addClass(this.options.noLoadedClass);
			this.count = 0;
			this.makeCallback('onFilter', this.activeItems, this.activeFilters);
			this.loadBoxes();

			if (!this.activeItems.length) {
				this.holder.addClass(this.options.noResultsClass);
			}
		},
		combineFilters: function(category, value) {
			if (value !== 'all') {
				if (this.activeFilters[category]) {
					this.activeFilters[category].push(value);
				} else {
					this.activeFilters[category] = [];
					this.activeFilters[category].push(value);
				}
			}
		},
		loadBoxes: function() {
			var self = this;
			var nextItems = this.activeItems.slice(this.count, this.count + this.options.itemsPerPage);

			this.ajaxBusy = true;
			this.count += this.options.itemsPerPage;
			this.holder.addClass(this.options.loadingClass);

			setTimeout(function() {
				self.holder.removeClass(self.options.loadingClass);
				nextItems.removeClass(self.options.noLoadedClass);
				self.ajaxBusy = false;
			}, this.options.delay);
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);

				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	$.fn.filteringItems = function(opt) {
		return this.each(function() {
			$(this).data('FilteringItems', new FilteringItems($.extend(opt, {
				holder: this
			})));
		});
	};
}(jQuery));
